<svelte:options tag="gema-information-box" />

<script>
    import { afterUpdate } from 'svelte';
    import marked from 'marked';
    import { Props } from "web-adapter-js";
    const props = new Props();

    export let key = '';
    export let data = {
        title: '',
        description: '',
        img: { url: '' }
    };

    afterUpdate(() => {
        const property = props.find(`gema-information-box-${key}`);
        if (!!key && property) { data = property; }
    });

    const isImage = (item) => !!item.img ? !!item.img.url : null;

</script>

<main>

    <section class="section-card">
        <div class="description">
            <h1> { data.title } </h1>
            <p class="text-description"> {@html marked(  data.description )} </p>
        </div>
        <div class="image">
            {#if isImage(data) }
                <img src={ data.img.url } alt="" class="noFloat">
            {/if}
        </div>
    </section>
</main>

<style type="text/scss">
    @import '../../../styles';
    @import '../../../scss/abstracts/mixins';

    .section-card {
        display: flex;
        flex-direction: column;
        align-items: normal;
        border-radius: 15px;
        background-color: #ffffff;

        .description {
            width: 53%;
            padding: 25px 50px;
            h1 {
                @include font-poppins(40px, 600, normal, normal, normal, -1.5px, #332927);
                margin-bottom: 20px;
            }
            p {
                @include font-poppins(15px, normal, normal, normal, 1.22, normal, #706967);
                text-align: justify;
            }
        }
        .image {
            position: relative;
            img {
                width: 440px;
                height: 100%;
                object-fit: cover;
                border-radius: 0 15px 15px 0;
            }
        }

        @media (max-width: 1279px) {
            flex-direction: column;
            .description { padding: 15px 30px; width: initial }
            .image {
                img {
                    width: 100%;
                    height: 161px;
                    object-fit: cover;
                    border-radius: 0 0 15px 15px;
                }
            }
        }

        @media (min-width: 1280px) {
            flex-direction: row;
            .description { width: 53%; }
        }
    }
</style>
